 const actions={
GET_PROJECTS_DATA:"GET_PROJECTS_DATA",
GET_Client_DATA:"GET_Client_DATA",
GET_Faq_DATA:"GET_Faq_DATA",
GET_Info_DATA:"GET_Info_DATA",
SIGN_IN_INFO:"SIGN_IN_INFO",
SAVE_IN_INFO:"SAVE_IN_INFO",
}
export default actions